import Card from "@/components/Card";
import DatePicker from "@/components/DatePicker";
import { Button } from "@/components/ui/button";
import { format } from "date-fns";
import { useState } from "react";
import { useTranslation } from "react-i18next";

interface Props {
  onCertificateIssue: (date: string) => void;
  issuingCertificate: boolean;
}

function CertificateIssuanceCard({
  onCertificateIssue,
  issuingCertificate,
}: Props) {
  const [issuanceDate, setIssuanceDate] = useState<string | undefined>(
    undefined,
  );
  const { t } = useTranslation();
  return (
    <Card className="p-5">
      <p className=" text-base font-medium text-cool-gray-900">
        {t("certificate-issuance")}
      </p>
      <p className=" text-sm font-normal text-cool-gray-600 mt-1">
        {t("certificate-issuance-message")}
      </p>
      <div className=" flex flex-row mt-4 space-x-4">
        <DatePicker
          value={issuanceDate ? new Date(issuanceDate) : undefined}
          onDateChange={(date) => {
            setIssuanceDate(date ? format(date, "yyyy-MM-dd") : undefined);
          }}
        />
        <Button
          onClick={() => onCertificateIssue(issuanceDate!)}
          disabled={issuanceDate === undefined || issuingCertificate}
        >
          {t("confirm-certificate-issuance")}
        </Button>
      </div>
    </Card>
  );
}

export default CertificateIssuanceCard;
